import React from 'react';

import { CustomerCardErrorAlert } from './CustomerCardErrorAlert';
import { CUSTOMER_CARD_NR_EVENTS } from '../analytics';
import { logCustomerCardError } from '../utils/newRelicLogging';

interface ErrorBoundaryState {
    hasError: boolean;
}

interface CustomerCardErrorBoundaryProps extends React.PropsWithChildren {
    onError?: () => void;
}

class CustomerCardErrorBoundary extends React.Component<CustomerCardErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: CustomerCardErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logCustomerCardError(CUSTOMER_CARD_NR_EVENTS.RENDER_CRASH, `${error.message} | ${errorInfo.componentStack}`);
        this.props.onError?.();
    }

    render() {
        if (this.state.hasError) {
            return <CustomerCardErrorAlert />;
        }
        return this.props.children;
    }
}

export default CustomerCardErrorBoundary;
